module.exports = __webpack_public_path__ + "img/icon_building_3.ae7f6cad.png";